module.exports = __webpack_public_path__ + "img/kku-logo.b02f8e97.svg";